<template>
  <div id="email-editor-container">
    <div class="container">
      <div id="bar" style="text-align: left">
        <el-button style="margin-right: 15px; float: left" @click="goBack" size="mini" type="primary"><i
            class="fas fa-arrow-left"></i> Go Back</el-button>
        <h1 v-if="!id">New Email Template</h1>
        <h1 v-if="id">Edit: {{ title }}</h1>
        <span class="label">Title:</span>
        <el-input v-model="title" style="width: 270px" placeholder="Title"></el-input>
        <span class="label">User type:</span>

        <el-select v-model="user_type" placeholder="Select user type" style="margin-right: 10px; width: 220px"
          :disabled="id ? true : false">
          <el-option label="Parents / Staff / Teachers" value="parents_staff"></el-option>
          <el-option label="Admins Contacts" value="admin_contacts"></el-option>
          <el-option label="Unregistered Wonde Users" value="unregistered_wonde_users"></el-option>
          <el-option label="Other" value="other"></el-option>
        </el-select>
        <el-checkbox v-model="global" :disabled="!isNewTemplate">Global Template</el-checkbox>
        <span class="label">Type:</span>

        <el-select v-model="type" placeholder="Select template type" :disabled="id ? true : false"
          style="margin-right: 10px; width: 140px">
          <el-option label="Template" value="template"></el-option>
          <el-option label="Header" value="header"></el-option>
          <el-option label="Footer" value="footer"></el-option>
        </el-select>
        <hr style="background-color: transparent; margin: 2px 0px" />
        <span class="label">Get Tag:</span>
        <el-select v-model="field" placeholder="Show tag" style="width: 270px" filterable :disabled="!user_type">
          <el-option-group label="Tags / Variables">
            <el-option v-for="item in fieldOptions" :key="item.value" :label="item.value" :value="item.value">
            </el-option>
            <el-option key="email" label="EMAIL" value="email"> </el-option>
            <el-option key="USERP_DOMAIN" label="USERP_DOMAIN" value="USERP_DOMAIN">
            </el-option>
            <el-option v-if="user_type == 'parents_staff'" key="AUTOLOGIN_LINK" label="AUTOLOGIN_LINK"
              value="AUTOLOGIN_LINK">
            </el-option>
          </el-option-group>
          <el-option-group label="Headers">
            <el-option v-for="item in allHeaders" :key="item.id" :label="item.title" :value="item.id"></el-option>
          </el-option-group>
          <el-option-group label="Footers">
            <el-option v-for="item in allFooters" :key="item.id" :label="item.title" :value="item.id"></el-option>
          </el-option-group>
        </el-select>
        <span v-if="field" @click="copyText(selectedField)" style="
            display: inline-block;
            width: 250px;
            line-height: 30px;
            font-size: 10px;
            padding-left: 3px;
            color: green;
          ">
          {{ selectedField }}
        </span>
        <span class="label">Email Subject:</span>

        <el-input v-model="subject" style="width: 220px" placeholder="Email subject"></el-input>
        <!-- <el-button type="success" v-on:click="saveDesign"
          >Save Design</el-button
        > -->
        <el-dropdown split-button type="success" @click="saveDesign" :disabled="!user_type || !title || !subject"
          style="margin-left: 10px">
          Save Design
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item><el-button type="text" @click="saveDesignAndPreview">Save Design & Preview
                it</el-button></el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>

      <EmailEditor ref="emailEditor" v-on:load="editorLoaded" v-on:ready="editorReady" :min-height="minHeight"
        :max-height="maxHeight" />
    </div>
    <div>
      <h3>Guide</h3>
      <h4>Conditionals</h4>
      <p>
        Conditionals are used to display alternative or additional content to a
        customer based on a set of variables. A couple of simple examples might
        include:
      </p>
      <b>Showing a specific info on a user’s new_term flag:</b>
      <pre style="background: #bbb">
        <code>
          {% if users.new_term %}
          &lt;p&gt;New term is pending on your account.&lt;/p&gt;
          {% endif %}
        </code>
        </pre>
      <b>Or specific value:</b>
      <pre style="background: #bbb">
        <code>
          {% if users.staff_type == 4 %}
            &lt;p&gt;This message will be shown only to specific user type&lt;/p&gt;
          {% endif %}
        </code>
        </pre>
    </div>
    <el-dialog title="Preview Modal" :visible.sync="previewModal" :close-on-press-escape="false"
      :close-on-click-modal="false" :show-close="true">
      <div>Preview modal</div>
      <div>
        <el-input v-model="test_email" style="width: 270px" placeholder="Test email"></el-input>
        <el-input v-model="test_name" style="width: 270px" placeholder="Recipient name"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="sendPreview" :disabled="!test_email ||
          !test_email.includes('@') ||
          !test_email.includes('.')
          ? true
          : false
          ">Confirm</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  adminContactsFieldOptions,
  standardFieldOptions,
  otherFieldOptions,
  unregisteredWondeFieldOptions,
} from "@/constants/automations";
import { EmailEditor } from "vue-email-editor";
import { apiUrl } from "@/domain";
import dbConnection from "@/services/dbConnection";
import ApiService from "@/services/ApiService";
import unescapeJs from "unescape-js";

export default {
  name: "single_mailgun_template",
  components: {
    EmailEditor,
  },
  data() {
    return {
      minHeight: "500px",
      maxHeight: "9000px",
      title: "",
      subject: "",
      description: "",
      user_type: null,
      test_email: null,
      test_name: null,
      type: "template",
      design: null,
      id: null,
      field: null,
      global: false,
      isNewTemplate: null,
      allHeaders: [],
      allFooters: [],
      previewModal: false,
    };
  },
  computed: {
    fieldOptions() {
      if (this.user_type === "admin_contacts") {
        return adminContactsFieldOptions;
      } else if (this.user_type === "parents_staff") {
        return standardFieldOptions;
      } else if (this.user_type === "unregistered_wonde_users") {
        return unregisteredWondeFieldOptions;
      } else if (this.user_type === "other") {
        return otherFieldOptions;
      } else {
        return [];
      }
    },
    selectedField() {
      if (this.field.includes("HEADER_") || this.field.includes("FOOTER")) {
        return this.field;
      } else {
        return "%recipient." + this.field.replace(/\./g, "__") + "%";
      }
    },
  },
  methods: {
    // called when the editor is created
    editorLoaded() {
      this.$refs.emailEditor.editor.registerCallback(
        "image",
        function (file, done) {
          try {
            const formData = new FormData();
            formData.set("file", file.attachments[0]);
            dbConnection
              .post(apiUrl + "/api/uploadFile?public=true", formData, {
                headers: {
                  "content-type": "multipart/form-data",
                },
              })
              .then((resp) => {
                done({ progress: 100, url: resp.data });
                // done({ url: resp.data });
              });
          } catch (error) {
            alert(error);
          }

        }
      );
      // Pass the template JSON here
      // eslint-disable-next-line
      // this.$refs.emailEditor.editor.loadDesign({});
    },
    async copyText(mytext) {
      try {
        await navigator.clipboard.writeText(mytext);
        this.$notify.info({
          title: "Copied",
        });
      } catch ($e) {
        alert("Cannot copy");
      }
    },
    // called when the editor has finished loading
    editorReady() {
      // console.log("editorReady");
    },
    loadDesign() {
      // console.log("This design", this.design);
      this.$refs.emailEditor.editor.loadDesign(JSON.parse(this.design));
    },
    saveDesign(redirect) {
      this.$refs.emailEditor.editor.saveDesign((design) => {
        const designJson = JSON.stringify(design);
        this.design = JSON.stringify(design);
        this.$refs.emailEditor.editor.exportHtml((data) => {
          const foundVariables = this.getVariables(data.html);
          // const foundVariables = [], // an array to collect the strings that are foundVariables
          //   rxp = /%([^}]+)%/g;
          // let curMatch;

          // while ((curMatch = rxp.exec(data.html))) {
          //   foundVariables.push(curMatch[1]);
          // }

          const formData = {
            title: this.title,
            subject: this.subject,
            description: this.description,
            template: designJson,
            html: unescapeJs(data.html),
            variables: foundVariables,
            user_type: this.user_type,
            global: this.global,
          };
          if (this.id) {
            formData.id = this.id;
          }
          ApiService.automationsApi.saveMailTemplate(formData).then((resp) => {
            this.id = resp.data.id;
            this.$notify.info({
              title: "Saved",
            });
            if (redirect != false) {
              this.$router.push("/members/automations/mailgun_templates");
            }
          });
        });
      });
    },
    saveDesignAndPreview() {
      this.saveDesign(false);
      this.previewModal = true;
    },
    exportHtml() {
      this.$refs.emailEditor.editor.exportHtml((data) => {
        // console.log("exportHtml", data);
      });
    },
    getVariables(html) {
      const fields = this.fieldOptions.map((itm) => itm.value);
      const foundVariables = [];

      for (let index = 0; index < fields.length; index++) {
        const fieldName = fields[index].replace(/\./g, "__");
        if (
          html.includes(fieldName) &&
          foundVariables.indexOf(fields[index]) === -1
        ) {
          foundVariables.push(fields[index]);
        }
      }
      if (
        html.includes("AUTOLOGIN_LINK") &&
        this.user_type == "parents_staff"
      ) {
        foundVariables.push("AUTOLOGIN_LINK");
      }
      return foundVariables;
    },
    getHeadersFooters() {
      ApiService.automationsApi.getTemplates("headers_footers").then((resp) => {
        this.allHeaders = resp.data.headers;
        this.allFooters = resp.data.footers;
      });
    },
    sendPreview() {
      ApiService.automationsApi
        .sendPreviewEmail({
          id: this.id,
          email: this.test_email,
          name: this.test_name,
        })
        .then((resp) => {
          this.$notify.info({
            title: "Sent",
          });
          this.previewModal = false;
        });
    },
    goBack() {
      this.$router.push("/members/automations/mailgun_templates/");
    },
  },
  mounted() {
    const id = this.$route.params.id;
    if (id == "new") {
      const defaultDesign = "";
      this.isNewTemplate = true;
    } else {
      ApiService.automationsApi.getSingleMailTemplate(id).then((resp) => {
        this.id = id;
        const obj = resp.data;
        this.title = obj.title;
        this.subject = obj.subject;
        this.user_type = obj.user_type;
        this.type = obj.type;
        this.global = obj.global ? true : false;
        this.$refs.emailEditor.editor.loadDesign(JSON.parse(obj.template));
      });
    }
    this.getHeadersFooters();
  },
};
</script>
<style>
#email-editor-containerf,
#editor-1 {
  height: 70vh;
}

iframe {
  min-height: 500px !important;
}
</style>
<style scoped>
span.label {
  display: inline-block;
  width: 100px;
  text-align: center;
}
</style>
